import { Dictionary } from './Dictionary';

/**
 * model for containing maps of data of one type in both individual and array entries
 */
export interface Collection<T> {
  singles?: Dictionary<T>;
  arrays?: Dictionary<T[]>;
  maps?: Dictionary<Dictionary<T>>;
}
